<template>
	<Tabs/>
</template>

<script>
import Tabs from '@/components/Tabs'

export default {
	name: 'LevelConfig',
	components: {
		Tabs,
	},
}
</script>
